module.exports = __webpack_public_path__ + "static/media/image-768.374e1881.jpg";